import { render } from "./DropdownMenu.vue?vue&type=template&id=490cd953"
import script from "./DropdownMenu.vue?vue&type=script&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&lang=js"

import "./DropdownMenu.vue?vue&type=style&index=0&id=490cd953&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__